import {Component, Input, OnInit} from '@angular/core';
import {UserSummary} from '../../entity/userSummary.model';

@Component({
    selector: 'app-user-summary-field',
    templateUrl: './user-summary-field.component.html',
})
export class UserSummaryFieldComponent implements OnInit {

    @Input() entity: UserSummary;
    @Input() label: string;

    constructor() {
    }

    ngOnInit() {
    }

}
